/**
 * ANB Smile.io Loader Optimizer v3
 * ================================
 * Delays smile.io loading for better performance.
 * Theme: ANB-ella-662-Test-V36
 * 
 * v3 Changes (Dec 17, 2025):
 * - REMOVED requestIdleCallback - was firing within ~700ms, not 6000ms
 * - Now uses user interaction OR 8s fallback timeout only
 * - Delays Smile.io by ~7.3 seconds more, reducing TBT during critical render
 * 
 * v2 Changes (Dec 17, 2025):
 * - REMOVED expensive MutationObserver (was watching entire body)
 * - SIMPLIFIED trigger logic to single event listeners
 * - REDUCED duplicate timeouts
 * - CLEANER cleanup of event listeners
 */

(function() {
  'use strict';

  let smileLoaded = false;

  /**
   * Load smile.io widget
   */
  function loadSmile() {
    if (smileLoaded) return;
    smileLoaded = true;

    console.log('[ANB] Smile.io v3: Triggering load');

    // HyperSpeed handles script deferral automatically
    if (typeof window.MeroxIO_Function === 'function') {
      window.MeroxIO_Function();
    }

    // Single delayed init check (removed duplicate timeouts)
    setTimeout(function() {
      try {
        if (window.SweetTooth && typeof window.SweetTooth.init === 'function') {
          window.SweetTooth.init();
        }
        if (window.SmileUI && typeof window.SmileUI.init === 'function') {
          window.SmileUI.init();
        }
      } catch (e) {
        // Silently ignore - Smile may already be initialized
      }
    }, 500);
    
    // Cleanup all listeners
    cleanup();
  }

  // Cleanup function
  function cleanup() {
    window.removeEventListener('scroll', onFirstInteraction);
    document.removeEventListener('click', onFirstInteraction);
    document.removeEventListener('touchstart', onFirstInteraction);
  }

  // Single handler for all interactions
  function onFirstInteraction() {
    // Small delay after interaction to not block the interaction itself
    setTimeout(loadSmile, 1500);
  }

  /**
   * Initialize delayed loading - SIMPLIFIED
   * Removed: MutationObserver (was causing long tasks)
   * Removed: Multiple redundant timeouts
   * 
   * v3 FIX: Removed requestIdleCallback - it fires too early (~700ms)
   * Now relies on: user interaction OR 8s fallback
   */
  function init() {
    // Strategy 1: User interaction (scroll, click, touch)
    window.addEventListener('scroll', onFirstInteraction, { passive: true, once: true });
    document.addEventListener('click', onFirstInteraction, { passive: true, once: true });
    document.addEventListener('touchstart', onFirstInteraction, { passive: true, once: true });

    // v3 FIX: REMOVED requestIdleCallback - it fires within ~700ms, blocking main thread
    // requestIdleCallback has a timeout parameter but fires as soon as browser is idle
    // which is almost immediately after page load

    // Strategy 2: Single fallback timeout (extended from 7s to 8s)
    setTimeout(loadSmile, 8000);

    console.log('[ANB] Smile.io v3: Delayed loading initialized (interaction or 8s fallback)');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

